<template>
  <ig-page-base>
    <div class="box products__content">
      <div class="products__title-box">
        <h2 class="title products__title has-text-weight-semibold">
          {{ $t('storePages.product.products.title') }}
        </h2>

<!--        <b-button-->
<!--          type="is-success"-->
<!--          :label="$t('storePages.product.products.btnNewProduct')"-->
<!--        ></b-button>-->
      </div>

      <div class="products__filters">
        <div class="columns">
          <div class="column is-6">
            <form @submit.prevent="getProductsList()">
              <b-field grouped>
                <b-input
                  v-model="filters.query"
                  :placeholder="$t('storePages.product.products.filters.query')"
                  expanded />
                <p class="control">
                  <b-button
                    native-type="submit"
                    type="is-primary"
                    :label="$t('storePages.product.products.filters.btnSearch')"
                    :loading="loading"
                    :disabled="loading"
                  ></b-button>
                </p>
              </b-field>
            </form>
          </div>
          <div class="column">
            <b-switch
              v-model="expandAll"
              type="is-primary">
              {{ $t('storePages.product.products.filters.expand') }}
            </b-switch>
<!--            <b-button-->
<!--              type="is-primary"-->
<!--              icon-left="filter"-->
<!--              outlined-->
<!--              :label="$t('storePages.product.products.filters.btnFilters')"-->
<!--              :disabled="loading"-->
<!--              @click="showFilters = true"-->
<!--            ></b-button>-->

<!--            <ig-sidebar-filters-->
<!--              v-model="showFilters"-->
<!--              v-slot="{ filters }"-->
<!--              @submit="applyFilters"-->
<!--            >-->
<!--              <b-field-->
<!--                :label="$t('storePages.product.products.filters.enabled.label')"-->
<!--                label-position="inside">-->

<!--                <b-select-->
<!--                  v-model="filters.enabled"-->
<!--                 :placeholder="$t('storePages.product.products.filters.enabled.options.all')"-->
<!--                  expanded>-->
<!--                  <option :value="undefined">-->
<!--                    {{ $t('storePages.product.products.filters.enabled.options.all') }}-->
<!--                  </option>-->
<!--                  <option :value="true">-->
<!--                    {{ $t('storePages.product.products.filters.enabled.options.active') }}-->
<!--                  </option>-->
<!--                  <option :value="false">-->
<!--                    {{ $t('storePages.product.products.filters.enabled.options.inactive') }}-->
<!--                  </option>-->
<!--                </b-select>-->
<!--              </b-field>-->
<!--              <b-field-->
<!--                :label="$t('storePages.product.products.filters.type.label')"-->
<!--                label-position="inside">-->
<!--                <b-select v-model="filters.type" expanded>-->
<!--                  <option :value="null">-->
<!--                    {{ $t('storePages.product.products.filters.type.options.all') }}-->
<!--                  </option>-->
<!--                  <option value="SIMPLE">-->
<!--                    {{ $t('storePages.product.products.filters.type.options.simple') }}-->
<!--                  </option>-->
<!--                  <option value="CONFIGURABLE">-->
<!--                    {{ $t('storePages.product.products.filters.type.options.configurable') }}-->
<!--                  </option>-->
<!--                </b-select>-->
<!--              </b-field>-->
<!--            </ig-sidebar-filters>-->
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <div class="box has-text-centered has-text-primary">
            <strong class="is-size-3 has-text-primary">{{ total }}</strong>
            <small style="display: block">
              {{ $t('storePages.product.products.totals.total') }}
            </small>
          </div>
        </div>
        <div class="column is-6">
          <div class="box has-text-centered has-text-success">
            <strong class="is-size-3 has-text-success">{{ totalStock }}</strong>
            <small style="display: block">
              {{ $t('storePages.product.products.totals.totalStock') }}
            </small>
          </div>
        </div>
      </div>

      <hr />

      <div class="has-text-right" v-if="total > 0">
          <b-button
            type="is-success"
            :label="`Exportar ${total} produtos`"
            :loading="loading"
            :disabled="loading"
            @click="exportProducts()"
          ></b-button>
      </div>

      <b-table
        :loading="loading"
        :data="products"
        backend-sorting
        default-sort="createdAt"
        default-sort-direction="desc"
        paginated
        pagination-simple
        backend-pagination
        @page-change="onPageChange"
        :total="total"
        :per-page="filters.limit"
        :current-page.sync="filters.page"
        @sort="sort"
        @click="row => editProduct(row.id)"
        striped
        hoverable
        scrollable
        custom-detail-row
        detailed
        detail-key="sku"
        :opened-detailed="openedDetailed()"
      >
        <template #empty>
          <ig-empty />
        </template>

        <template #bottom-left>
          <ig-per-page
            :total-displayed="products.length"
            :total="total"
            :perPage="filters.limit"
            @change="changePerPage"
          />
        </template>

        <b-table-column
          field="name"
          :label="$t('storePages.product.products.table.header.product')"
          v-slot="props"
          sortable
        >
          <article class="media">
            <div class="media-left">
              <figure class="image is-64x64">
                <img
                  :src="Array.isArray(props.row.photos) && props.row.photos.length > 0
                  ? props.row.photos[0] : 'https://assets.integrai.com.br/store/no_image.png'"
                  :alt="props.row.name">
              </figure>
            </div>
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>{{ props.row.name }}</strong>
                </p>
              </div>
            </div>
          </article>
        </b-table-column>

        <b-table-column
          field="sku"
          :label="$t('storePages.product.products.table.header.sku')"
          v-slot="props"
          centered
          sortable
        >
          {{ props.row.sku }}
        </b-table-column>

        <b-table-column
          field="gtin"
          :label="$t('storePages.product.products.table.header.gtin')"
          v-slot="props"
          centered
          sortable
        >
          {{ props.row.gtin }}
        </b-table-column>

        <b-table-column
          field="stockQuantity"
          :label="$t('storePages.product.products.table.header.stock')"
          v-slot="props"
          centered
          sortable
        >
          {{ props.row.stockQuantity }}
        </b-table-column>

        <b-table-column
          field="price"
          :label="$t('storePages.product.products.table.header.price')"
          v-slot="props"
          centered
          sortable
        >
          <span :class="{
            'products__line-through': !!props.row.specialPrice,
          }">R$ {{ props.row.price | finance }}</span>
          <br>
          <span v-if="props.row.specialPrice">R$ {{ props.row.specialPrice | finance }}</span>

        </b-table-column>

        <b-table-column
          field="stockQuantity"
          :label="$t('storePages.product.products.table.header.locations')"
          v-slot="props"
          centered
          sortable
        >
          {{ transformLocations(props.row.locations).length }}
        </b-table-column>

<!--        <b-table-column-->
<!--          width="100"-->
<!--          v-slot="props"-->
<!--        >-->
<!--          <b-dropdown-->
<!--            aria-role="list"-->
<!--            position="is-bottom-left"-->
<!--            append-to-body>-->
<!--            <template #trigger>-->
<!--              <b-button-->
<!--                :label="$t('storePages.product.products.table.header.actions')"-->
<!--                type="is-primary"-->
<!--                size="is-small"-->
<!--                icon-right="caret-down" />-->
<!--            </template>-->

<!--            <b-dropdown-item aria-role="listitem" @click="editProduct(props.row.id)">-->
<!--              <b-icon-->
<!--                icon="external-link-alt"-->
<!--                size="is-small"/>-->
<!--              {{ $t('storePages.product.products.table.data.actions.view') }}-->
<!--            </b-dropdown-item>-->
<!--            <b-dropdown-item aria-role="listitem" @click="editProduct(props.row.id)">-->
<!--              <b-icon-->
<!--                icon="pen"-->
<!--                size="is-small"/>-->
<!--              {{ $t('storePages.product.products.table.data.actions.edit') }}-->
<!--            </b-dropdown-item>-->
<!--            <b-dropdown-item aria-role="listitem" @click="deleteProduct(props.row.id)">-->
<!--              <b-icon-->
<!--                icon="trash"-->
<!--                size="is-small"/>-->
<!--              {{ $t('storePages.product.products.table.data.actions.delete') }}-->
<!--            </b-dropdown-item>-->
<!--          </b-dropdown>-->
<!--        </b-table-column>-->

        <template slot="detail" slot-scope="props">
          <tr v-for="location in transformLocations(props.row.locations)" :key="location.location">
            <td></td>
            <td></td>
            <td></td>
            <td align="right">
              <span class="tag is-light is-primary is-medium">
                <strong style="margin-right: 1rem">Localização:</strong>
                {{ location.location }}
              </span>
            </td>
            <td align="center">
              {{ location.quantity }}
            </td>
            <td></td>
            <td></td>
          </tr>
        </template>
      </b-table>
    </div>
  </ig-page-base>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import {
  IgPageBase,
  IgEmpty,
  // IgSidebarFilters,
  IgPerPage,
} from '@integrai/ui';

const { mapState, mapActions } = createNamespacedHelpers('products');

export default Vue.extend({
  name: 'page-products',
  components: {
    IgPageBase,
    IgEmpty,
    // IgSidebarFilters,
    IgPerPage,
  },
  data() {
    return {
      showFilters: false,
      expandAll: false,
      filters: {
        limit: 10,
        page: 1,
      },
    };
  },
  computed: {
    ...mapState([
      'loading',
      'products',
      'total',
      'totalStock',
    ]),
  },
  methods: {
    ...mapActions([
      'getProducts',
      'exportAllProducts',
    ]),
    sort(sortField, sortOrder) {
      Object.assign(this.filters, {
        sortField,
        sortOrder,
      });

      this.getProductsList();
    },
    onPageChange(page) {
      Object.assign(this.filters, {
        page,
      });

      this.getProductsList();
    },
    changePerPage(limit) {
      Object.assign(this.filters, {
        limit,
      });

      this.getProductsList();
    },
    applyFilters(filters) {
      this.getProductsList({
        ...this.filters,
        ...filters || {},
      });
    },
    async getProductsList(filters) {
      await this.getProducts(filters || this.filters);
    },
    editProduct(productId) {
      console.log('productId', productId);
    },
    deleteProduct(productId) {
      console.log('productId', productId);
    },
    openedDetailed() {
      if (!this.expandAll) {
        return [];
      }

      return this.products.map((product) => product.sku);
    },
    transformLocations(locations) {
      return Object.keys(locations).map((location) => ({
        location,
        quantity: locations[location],
      })).sort((a, b) => b.quantity - a.quantity);
    },
    async exportProducts() {
      const response = await this.exportAllProducts();
      const url = window.URL.createObjectURL(new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'produtos.xlsx');
      document.body.appendChild(link);
      link.click();
    },
  },
  async beforeMount() {
    await this.getProductsList();
  },
});
</script>

<style lang="scss">
  .products{
    &__title-box{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    &__title{
      padding-bottom: 1rem;
    }
    &__line-through {
      text-decoration: line-through;
    }
  }
</style>
